import type {StateCreator} from 'zustand'
import type {ChangeGroupOrchestration, Group} from '../../types/group-types'

export type ChangeGroupGenerationSliceOpts = {
  changeGroupGeneration: {
    canAccessChangeGroups: boolean
    changeGroups: Group[]
    latestChangeGroupOrchestration: ChangeGroupOrchestration | null
  }
}
export type ChangeGroupGenerationSlice = {
  changeGroupGeneration: {
    canAccessChangeGroups: boolean
    changeGroups: Group[]
    latestChangeGroupOrchestration: ChangeGroupOrchestration | null
  }
}

export const createChangeGroupGenerationSlice =
  ({
    changeGroupGeneration: {canAccessChangeGroups, changeGroups, latestChangeGroupOrchestration},
  }: ChangeGroupGenerationSliceOpts): StateCreator<
    ChangeGroupGenerationSlice,
    [['zustand/devtools', never]],
    [],
    ChangeGroupGenerationSlice
  > =>
  () => ({
    changeGroupGeneration: {
      canAccessChangeGroups,
      changeGroups,
      latestChangeGroupOrchestration,
    },
  })
